import { render, staticRenderFns } from "./Create-Purchase-Order.vue?vue&type=template&id=0a1018ba&"
import script from "./Create-Purchase-Order.vue?vue&type=script&lang=js&"
export * from "./Create-Purchase-Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports